export default __webpack_public_path__ + "static/media/Videography1.8389c77c.png";